import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class IncomeService {
  constructor(private http: HttpClient, private restService: RestService) {}
  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('income/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('income/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('income/save', data);
  }

  saveAmortizationBooking(data: any) {
    return this.restService.save('money/income/save/amortization_booking', data);
  }

  saveAmortizationExtends(data: any) {
    return this.restService.save('money/income/save/amortization_extends', data);
  }
  
  update(val_id: number, data: any) {
    return this.restService.update('income/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('income/delete', val_id);
  }
}
